import {StaticOptionConstant, StaticValuesConstant} from "@/models/modules/constants/StaticOptionConstant"

export const urssafEvent: StaticOptionConstant = {
  uuid: 'e7d653d5-fa45-11ed-a0b1-de1c3c38600f',
  name: 'Urssaf Event',
  values: [
    {label: 'Naissance', value: '4bf6fc49-10e4-11ee-961e-024264400006', databaseValue: '1'},
    {label: 'Mariage', value: '4bf9191a-10e4-11ee-961e-024264400006', databaseValue: '2'},
    {label: 'Retraite', value: '4bfae864-10e4-11ee-961e-024264400006', databaseValue: '3'},
    {label: 'Noël adulte', value: '4bfd3e6e-10e4-11ee-961e-024264400006', databaseValue: '4'},
    {label: 'Noël enfant', value: '4bff0f2a-10e4-11ee-961e-024264400006', databaseValue: '5'},
    {label: 'Rentrée scolaire', value: '4c01591e-10e4-11ee-961e-024264400006', databaseValue: '6'},
    {label: 'Fête des mères/pères', value: '4c03b54c-10e4-11ee-961e-024264400006', databaseValue: '7'},
    {label: 'Sainte Catherine / Saint Nicolas', value: '4c05c2ac-10e4-11ee-961e-024264400006', databaseValue: '8'},
  ],
}

export const socialEvent:  StaticValuesConstant =  {
    name: 'Social Event',
    values: [
    { label: 'Culture', value: '15c786e0-9eba-4434-872a-081465529704', databaseValue: '1' },
    { label: 'Naissance', value: '0b4d4ca7-24fc-4b4f-9f57-965b22ccc15f', databaseValue: '2' },
    { label: 'Noel', value: '4d1a680f-c4a4-4ac0-9c10-7c150de44741', databaseValue: '3' },
    { label: 'Vacances', value: 'efb949f8-3423-42f7-b98c-5ed68d8d1da5', databaseValue: '4' },
    { label: 'Rentrée scolaire', value: '7a7d6425-a28e-4882-8fc0-1a3da9fa0049', databaseValue: '5' },
    { label: 'Retraite', value: '056a7b93-dbc7-46ef-b4aa-50a23a0b8e81', databaseValue: '6' },
    { label: 'Mariage', value: '9e1bfdf9-b432-41ac-abcb-d9b90c561425', databaseValue: '7' },
    { label: 'Sport', value: 'e5e775de-4d43-48ae-a91d-596d8d9c5281', databaseValue: '8' },
    { label: 'Fête des mères/pères', value: '89de6b06-0aad-4b8f-8653-477010f144b9', databaseValue: '9' },
    { label: 'Sainte-Catherine/Saint-Nicolas', value: 'a3762c0e-3874-4e63-a815-1cf8bfc23d08', databaseValue: '10' },
    { label: 'Sans restriction', value: 'd1f021c6-2354-44b0-be19-340cee0dadb5', databaseValue: '11' }
    ],
}


export const urssafClassification: StaticOptionConstant = {
  uuid: 'e7d49bb6-fa45-11ed-a0b1-de1c3c38600f',
  name: 'Urssaf Classificiation',
  values: [
    {label: 'Culture', value: '4bede92c-10e4-11ee-961e-024264400006', databaseValue: '1'},
    {label: 'Vacances/Voyages', value: '4bf04945-10e4-11ee-961e-024264400006', databaseValue: '2'},
    {label: 'Sport', value: '4bf2200d-10e4-11ee-961e-024264400006', databaseValue: '3'},
    {label: 'Autre', value: '4bf45018-10e4-11ee-961e-024264400006', databaseValue: '4'},
  ],
}

export const PRODUCT_PROTOTYPES = 
    {
      TICKET: '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f', 
      GIFT: '6a3fe435-fdfd-11ed-a0b1-de1c3c38600f', 
      PHYSICAL: '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f', 
      PROMO: '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f', 
      MEMBER: '6a401dea-fdfd-11ed-a0b1-de1c3c38600f',
    }
